export function maskEmail(value: string | null | undefined): string {
  if (!value) return '—';
  const at = value.indexOf('@');
  if (at <= 0) return '***';
  const local = value.slice(0, at);
  const domain = value.slice(at + 1);
  return `${local.slice(0, Math.min(2, local.length))}***@${domain}`;
}

export function maskPhone(value: string | null | undefined): string {
  if (!value) return '—';
  const digits = value.replace(/\D/g, '');
  if (digits.length < 4) return '******';
  return `******${digits.slice(-4)}`;
}

export function sourceBadgeClass(source: string | null | undefined): string {
  switch (source) {
    case 'ERP':
      return 'badge-source-erp';
    case 'GARAGES':
      return 'badge-source-garages';
    case 'FLOWW':
      return 'badge-source-floww';
    default:
      return 'badge-neutral';
  }
}

export function sourceLabel(source: string | null | undefined): string {
  switch (source) {
    case 'ERP':
      return 'ERP';
    case 'GARAGES':
      return 'Garages';
    case 'FLOWW':
      return 'FLOWW';
    default:
      return 'Unknown source';
  }
}
